import { render } from "./MatchPlay.vue?vue&type=template&id=0bf04866"
import script from "./MatchPlay.vue?vue&type=script&lang=ts"
export * from "./MatchPlay.vue?vue&type=script&lang=ts"
script.render = render

export default script